import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const CustomPagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  return (
    <Stack spacing={2} alignItems="center" pt={2}>
      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={(event, value) => onPageChange(value)}
        color="primary"
      />
    </Stack>
  );
};

export default CustomPagination;